import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { Link } from "react-router-dom";
import { BLOG_STATUS, Blog_Type } from "../model";
import { db } from "../firebase";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Loading from "../components/Loading";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectedBlogActions } from "../store/features/selectedBlog";

const blogTypes = [
  { name: "All", value: BLOG_STATUS.NONE },
  { name: "Programming", value: BLOG_STATUS.Programming },
  { name: "Mathematics", value: BLOG_STATUS.Mathematics },
  { name: "Physics", value: BLOG_STATUS.Physics },
];

function BlogsList() {
  const dispatch = useAppDispatch();
  const selectedBlog = useAppSelector((state) => state.selectedBlog);
  const [blogs, setBlogs] = useState<Blog_Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    if (selectedBlog === BLOG_STATUS.NONE) {
      onSnapshot(collection(db, "blogs"), (snapshot) => {
        let data = [] as Blog_Type[];
        snapshot.forEach((doc) => {
          data.push(doc.data() as Blog_Type);
        });

        setBlogs(data.sort((a, b) => b.date - a.date));
        setLoading(false);
      });
    } else {
      onSnapshot(collection(db, "blogs"), (snapshot) => {
        let data = [] as Blog_Type[];
        snapshot.forEach((doc) => {
          if (doc.data().type === selectedBlog) {
            data.push(doc.data() as Blog_Type);
          }
        });

        setBlogs(data.sort((a, b) => b.date - a.date));
        setLoading(false);
      });
    }
  }, [selectedBlog]);

  return (
    <div className="w-full max-w-5xl p-6 cursor-pointer mx-auto space-y-5">
      <div className="w-full flex justify-center  sticky top-20">
        <select
          value={selectedBlog}
          onChange={(e) =>
            dispatch(
              selectedBlogActions.setSelectedBlog(e.target.value as BLOG_STATUS)
            )
          }
          name=""
          id=""
          className="w-[50%] p-3 rounded-md shadow"
        >
          {blogTypes.map((blogType) => (
            <option key={blogType.value} value={blogType.value}>
              {blogType.name}
            </option>
          ))}
        </select>
      </div>
      <ul className="flex flex-col justify-start gap-5 select-none">
        {(loading || !blogs.length) && <Loading />}
        {blogs.map((blog) => (
          <Link
            to={`/blogs/${blog.id}`}
            key={blog.id}
            className="w-full rounded-md shadow-md bg-white p-4 hover:bg-gray-50 hover:scale-[1.02] hover:shadow-lg hover:text-sky-500 transition-all duration-500 ease-in-out"
          >
            <h1 className="text-2xl">{blog.title}</h1>
            <p className="text-gray-500 text-end">{blog.author}</p>
            <p className="text-gray-400 text-end text-sm">
              {new Date(blog.date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <summary className="text-gray-500">{blog.summary}</summary>
            <p className="text-end text-sm text-gray-500">
              <VisibilityIcon fontSize="small" color="primary" />{" "}
              {blog.numberOfReads}
            </p>
          </Link>
        ))}
      </ul>
    </div>
  );
}

export default BlogsList;
